import { Component, ChangeDetectionStrategy, Input, Optional, HostListener } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import * as Utils from '@shared/core/utils';
import { ScrollService } from '@shared/core/directives/scroll/scroll.shared.service';

@Component({
    template: '<div>This component requires extending</div>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalViewComponent {
    public scrollParentContainer: HTMLElement;
    public disabled: boolean = false; /* Consumer -> quantity */
    public remove: boolean = false; /* Consumer -> quantity */
    public minimumHide: boolean = true; /* Consumer -> quantity */
    public buttonLabel: string = 'Add to bag'; /* Add to bag, Edit item, No, thanks. Consumer -> button */
    public iconInsteadOfImage: boolean = false; /* Consumer -> vcard -> square-image */
    public size: OLO.Components.MODAL_SIZE; /* Consumer -> modal-box */
    public showButtonPrice: boolean = true;
    public minHeight: number = 0; /* Consumer -> shared-modal-content */
    public shadow: boolean = false; /* Consumer -> shared-modal-content */
    public dimmedBg: boolean = false; /* Consumer -> shared-modal-content */
    public fullPaddings: boolean = false; /* Consumer -> shared-modal-content */
    public showSubHeader: boolean = false; /* Consumer -> modal-type  */
    public collapseHeader: boolean = false; /* Consumer -> shared-vcard */

    public twoColumnsAlign: OLO.Components.TWO_COLUMNS_ALIGN = 'center'; /* Consumer -> shared-two-columns */
    public twoColumnsAdjust: OLO.Components.TWO_COLUMNS_ADJUST; /* Consumer -> shared-two-columns */
    public twoColumnsMarginBottom: OLO.Components.MARGIN_SIZE = 'none'; /* Consumer -> shared-two-columns */

    @Input() public modalData: State.IModal;

    @HostListener('window:olo:modal:backdrop-click', ['$event']) public handleBackdropClick($event: Event): void {
        this.handleCloseClick({ event: $event, modalId: this.modalData.id });
    }

    constructor(
        public modalsService: Services.ModalsService,
        @Optional() public heightAdjustService: Services.HeightAdjustService,
        @Optional() public scrollService: ScrollService
    ) { }

    public close(): void {
        this.modalsService.close(this.modalData.id);
    }

    public handleCloseClick($event: OLO.Components.Modals.ICloseEvent): void {
        this.modalsService.close(this.modalData.id);
    }

    public handleScrollInit($event: HTMLElement): void {
        this.scrollParentContainer = $event;
    }

    public handleHeightUpdate(): void {
        if (this.scrollService) {

            if (this.scrollParentContainer) {
                Utils.Scroll.smoothScrollInnerElement(this.scrollParentContainer, 0, 0, 0);
            }
            setTimeout(() => {
                this.scrollService.requestUpdate();
                if (this.heightAdjustService) this.heightAdjustService.recalculateHeight(`modal-${this.modalData.id}`);
            }, 10);

        } else {
            setTimeout(() => {
                if (this.heightAdjustService) {
                    this.heightAdjustService.recalculateHeight(`modal-${this.modalData.id}`);
                }
            }, 10);

        }


    }
}
